import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxThemeState} from '../../@interfaces';
import {
	THEME_CLOSE_MOBILE_SIDEBAR,
	THEME_OPEN_MOBILE_SIDEBAR,
	THEME_SET_BIG_SIDEBAR_SIZE,
	THEME_SET_DARK,
	THEME_SET_DESKTOP_VERSION,
	THEME_SET_LIGHT,
	THEME_SET_MOBILE_VERSION,
	THEME_SET_SMALL_SIDEBAR_SIZE,
	THEME_TOGGLE,
	THEME_TOGGLE_MOBILE_SIDEBAR,
	THEME_TOGGLE_SIDEBAR_SIZE
} from './constants';
import DotAccessor from '../../services/DotAccessor/DotAccessor';

const accessor = new DotAccessor();

const reducer: Reducer = (state: IReduxThemeState = initialState, action: IReduxAction): IReduxThemeState => {
	const set = (path: string, value: any): IReduxThemeState => {
		const newState = {...state};
		accessor.set(newState, path, value);

		return newState;
	};

	switch (action.type) {
		case THEME_TOGGLE:
			return {...state, dark: !state.dark, light: !state.light};

		case THEME_SET_DARK:
			return {...state, dark: true, light: false};

		case THEME_SET_LIGHT:
			return {...state, dark: false, light: true};

		case THEME_SET_MOBILE_VERSION:
			return {...state, isMobileVersion: true};

		case THEME_SET_DESKTOP_VERSION:
			return {...state, isMobileVersion: false};

		case THEME_OPEN_MOBILE_SIDEBAR:
			return set('sidebar.mobile.open', true);

		case THEME_CLOSE_MOBILE_SIDEBAR:
			return set('sidebar.mobile.open', false);

		case THEME_TOGGLE_MOBILE_SIDEBAR:
			return set('sidebar.mobile.open', !state.sidebar.mobile.open);

		case THEME_TOGGLE_SIDEBAR_SIZE:
			return set('sidebar.desktop.size', state.sidebar.desktop.size === 'big' ? 'small' : 'big');

		case THEME_SET_SMALL_SIDEBAR_SIZE:
			return set('sidebar.desktop.size', 'small');

		case THEME_SET_BIG_SIDEBAR_SIZE:
			return set('sidebar.desktop.size', 'big');

		default:
			break;
	}

	return state;
};

export default reducer;
